import type {
  Appointment,
  AppointmentApiResource,
  AppointmentDraft,
  AppointmentWritePayload,
  OwnerAppointment,
  OwnerAppointmentApiResource,
} from './appointmentsApi.types';

function extractIsoDateOnly(possibleIsoDate: string): string {
  if (possibleIsoDate.length >= 10) {
    return possibleIsoDate.substring(0, 10);
  }
  return possibleIsoDate;
}

export function mapApiResourceToAppointment(apiResource: AppointmentApiResource): Appointment {
  return {
    id: apiResource.id,
    date: extractIsoDateOnly(apiResource.date),
    startTime: apiResource.start_time,
    endTime: apiResource.end_time,
    patientId: apiResource.patient_id,
    patientName: apiResource.patient_name,
    clientName: apiResource.client_name,
    therapyType: apiResource.therapy_type,
    status: apiResource.status,
    note: apiResource.note,
    cancelledBy: apiResource.cancelled_by,
    rescheduleRequestedAt: apiResource.reschedule_requested_at,
    rescheduleRequestMessage: apiResource.reschedule_request_message,
  };
}

export function mapApiResourceToOwnerAppointment(
  apiResource: OwnerAppointmentApiResource
): OwnerAppointment {
  return {
    id: apiResource.id,
    date: extractIsoDateOnly(apiResource.date),
    startTime: apiResource.start_time,
    endTime: apiResource.end_time,
    patientId: apiResource.patient_id,
    patientName: apiResource.patient_name,
    therapyType: apiResource.therapy_type,
    status: apiResource.status,
    cancelledBy: apiResource.cancelled_by,
    rescheduleRequestedAt: apiResource.reschedule_requested_at,
    cancellationDeadline: apiResource.cancellation_deadline,
    canCancel: apiResource.can_cancel,
    canRequestReschedule: apiResource.can_request_reschedule,
  };
}

export function mapDraftToApiPayload(appointmentDraft: AppointmentDraft): AppointmentWritePayload {
  return {
    patient_id: appointmentDraft.patientId,
    date: appointmentDraft.date,
    start_time: appointmentDraft.startTime,
    end_time: appointmentDraft.endTime,
    therapy_type: appointmentDraft.therapyType,
    status: appointmentDraft.status,
    note: appointmentDraft.note,
  };
}
